import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ProductBagIconButton from "./Header/ProductBagIconButton";

const MiniCart = () => {
    const { quantity, orderTotal, checkoutUrl, showInfo } = useSelector(
        (state) => state.cart
    );
    return (
        <ProductBagIconButton quantity={quantity} text="Quote" icon="quote" href={checkoutUrl} active={quantity > 0}/>
    );
};

export default MiniCart;
